import { Component, inject } from "@angular/core";
import { TablerIconComponent } from "angular-tabler-icons";
import { MaterialModule } from "src/app/core/material.module";
import { UserService } from "src/app/core/services/user.service";

@Component({
  selector: "app-font-size",
  standalone: true,
  imports: [MaterialModule, TablerIconComponent],
  templateUrl: "./font-size.component.html",
})
export class FontSizeComponent {
  // Injections
  public userService = inject(UserService);

  // Variables
  fontSize = 97.75;
  increaseDecrease = 1;

  setFontSize(idd: string) {
    if (idd === "a+") {
      if (this.fontSize < 121.75) {
        this.fontSize += 1;
      }
    } else if (idd === "a-") {
      if (this.fontSize > 89.75) {
        this.fontSize -= 1;
      }
    } else {
      this.fontSize = 97.75;
    }

    const htmlRoot: HTMLElement = document.getElementsByTagName(
      "html",
    )[0] as HTMLElement;
    if (htmlRoot != null) {
      htmlRoot.style.fontSize = `${this.fontSize}%`;
      this.userService.setFontSize(this.fontSize);
    }
  }
}
